import React, { useEffect, useState } from "react";

import { CgMenuRight, CgClose } from "react-icons/cg";

import NavMobile from "./NavMobile";

import { navigation } from "../data";

const Header = () => {
  const [bg, setBg] = useState(false);

  const [mobileNav, setMobileNav] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      return window.scrollY > 50 ? setBg(true) : setBg(false);
    });
  });

  const handleNav = () => {
    setMobileNav(!mobileNav);
  };

  return (
    <header
      className={`${
        bg ? "bg-[#5E514B] py-4 lg:py-4" : "bg-none"
      } fixed left-0 w-full py-4 z-10 transition-all duration-200`}
    >
      <div className="container mx-auto">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl text-white font-bold">HP Enterprises</h1>

          <div
            onClick={() => setMobileNav(!mobileNav)}
            className="text-white text-2xl md:hidden lg:text-3xl cursor-pointer"
          >
            {mobileNav ? <CgClose /> : <CgMenuRight />}
          </div>
          <nav className="hidden md:flex">
            <ul className="md:flex md:gap-x-12">
              {navigation.map((item, index) => {
                return (
                  <li key={index}>
                    <a
                      className="text-white capitalize hover:border-b transition-all"
                      href={`#${item.href}`}
                    >
                      {item.href}
                    </a>
                  </li>
                );
              })}
            </ul>
          </nav>
          <div
            className={`${
              mobileNav ? "left-0" : "-left-full"
            } md:hidden fixed bottom-0 w-full max-w-xs h-screen transition-all`}
          >
            <NavMobile handleNav={handleNav} />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
